var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1759"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20A10.01 10.01 0 0 1 0 10 10.01 10.01 0 0 1 10 0a10.01 10.01 0 0 1 10 10 10.01 10.01 0 0 1-10 10m0-5.953a1.05 1.05 0 0 0-.766.32 1.04 1.04 0 0 0-.32.758 1.07 1.07 0 0 0 .312.781 1.06 1.06 0 0 0 .774.312 1.05 1.05 0 0 0 .765-.312 1.06 1.06 0 0 0 .32-.774 1.05 1.05 0 0 0-.32-.765 1.05 1.05 0 0 0-.765-.32m-.883-10.11v9.375h1.766V3.937Z",
    "data-name": "Exclusion 40"
  }))));
};
export default SvgInfo;